export default {
  created() {
    this.opts = {
      headers: {},
      withCredentials: true,
    };
  },
  mounted() {
    this.setLocale(localStorage.getItem("lang"));
  },
  methods: {
    setLocale(value) {
      const locale = value && value !== 'null' && value !== 'undefined' ? value : 'en';
      // vue-i18n (legacy mode)
      if (this.$i18n) this.$i18n.locale = locale;
      // Vuetify 3
      if (this.$vuetify?.locale) {
        this.$vuetify.locale.current = locale;
      }
    },
    setExpiredSession() {
      document.dispatchEvent(
        new CustomEvent("session-expired", {
          detail: {
            storage: true,
          },
        }),
      );
    },
  },
};
